import { featureFlagRequests } from "@/api/(requests)/featureFlagTyped";

export function handleFeatureFlagError(error, flagName, isEnabled) {
  featureFlagRequests.post_feature_flag_error({
    body: { enabled: isEnabled, flag_name: flagName },
  });
  throw error;
}
